<template>
    <section class="question">
        <div class="question__animation" v-if="animation">
            <lottie-player
                ref="lottie"
                class="question__player"
                background="transparent"
                speed="1"
                loop
                autoplay></lottie-player>
        </div>
        <div class="question__content" :class="{'question__content--no-col': !animation}">
            <div class="range">
                <p class="supertitle" v-if="questionNumber">otázka {{ questionNumber }}</p>
                <h2 class="title">{{ title }}</h2>
                <p class="subtitle" v-if="subtitle">{{ subtitle }}</p>
                <div class="range__inner">
                    <div class="range__min range__min--desktop">{{ min }} {{ unit }}</div>
                    <div class="range__wrap">
                        <output class="range__bubble" :for="name" ref="bubble"></output>
                        <input type="range" :min="min" :max="max" :step="step" v-model="value" :name="name" ref="range">
                    </div>
                    <div class="range__max range__max--desktop">{{ max }} {{ unit }}</div>
                </div>
                <div class="range__mobile">
                    <div class="range__min">{{ min }} {{ unit }}</div>
                    <div class="range__max">{{ max }} {{ unit }}</div>
                </div>
            </div>
            <slot></slot>
        </div>
    </section>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import animation from "@/mixins/animation";

export default {
    name: "GroheRange",
    mixins: [animation],
    props: {
        min: {
            type: Number,
            required: true
        },
        max: {
            type: Number,
            required: true
        },
        step: {
            type: Number,
            default: 1
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String
        },
        name: {
            type: String,
            required: false
        },
        valuePerUnit: {
            type: Number,
            required: true
        },
        unit: {
            type: String,
            required: true
        },
        questionNumber: {
            type: String
        }
    },
    data() {
        return {
            value: 0,
        }
    },
    validations: {
        value: {
            required
        },
        form: ['value']
    },
    methods: {
        validate() {
            this.$v.form.$touch();
            const isValid = !this.$v.form.$invalid;
            this.$emit('on-validate', isValid, this.name, (parseInt(this.value) * this.valuePerUnit));
            return isValid;
        },
        setBubble() {
            const range = this.$refs.range;
            const bubble = this.$refs.bubble;
            const val = range.value;
            const min = range.min ? range.min : 0;
            const max = range.max ? range.max : 100;
            const newVal = Number(((val - min) * 100) / (max - min));
            bubble.innerHTML = val;

            // magic numbers incoming
            bubble.style.left = `calc(${newVal}% - ${9 + (val * 1.1) }px`;
        },
    },
    mounted() {
        this.$refs.range.addEventListener("input", () => {
            this.setBubble();
        });
    }
}
</script>

<style scoped lang="scss">
.range {
    $this: &;
    &__inner {
        display: flex;
        margin: auto;
        position: relative;
        padding-top: 75px;
    }
    &__bubble {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        left: -13px;
        width: 50px;
        height: 72px;
        position: absolute;
        font-weight: 600;
        color: white;
        background-image: url("~@/assets/bubble.svg");
        background-repeat: no-repeat;
        background-position: center;
        transform: scale(0.7);
        top: -63px;
        font-size: 17px;
        &:empty {
            display: none;
        }
    }
    &__wrap {
        width: 100%;
        display: flex;
        position: relative;
    }
    &__max {
        padding-left: 0;
        &--desktop {
            padding-left: 40px;
            display: none;
        }
    }
    &__min {
        padding-right: 0;
        &--desktop {
            padding-right: 40px;
            display: none;
        }
    }
    &__min,
    &__max {
        white-space: nowrap;
        font-size: 22px;
        color: $delft;
    }
    &__mobile {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        > #{$this}__min,
        > #{$this}__max {
            font-size: 16px;
        }
    }

    @media screen and (min-width: $mq-sm) {
        &__mobile {
            display: none;
        }
        &__bubble {
            top: -72px;
            font-size: 15px;
            transform: none;
        }
        &__max {
            &--desktop {
                display: block;
            }
        }
        &__min {
            &--desktop {
                display: block;
            }
        }
    }
}
input[type=range] {
    width: 100%;
    margin: 11.2px 0;
    background-color: transparent;
    -webkit-appearance: none;
}

input[type=range]:focus {
    outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
    background: #3F5D8A;
    border: 0;
    border-radius: 0.3px;
    width: 100%;
    height: 3px;
    cursor: pointer;
}

input[type=range]::-webkit-slider-thumb {
    margin-top: -8px;
    width: 33px;
    height: 20px;
    background: #1a3066;
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    -webkit-appearance: none;
    background-image: url("~@/assets/thumb.svg");
    background-size: 10px 8px;
    background-position: center;
    background-repeat: no-repeat;
}

input[type=range]:focus::-webkit-slider-runnable-track {
    background: #3F5D8A;
}

input[type=range]::-moz-range-track {
    background: #3F5D8A;
    border: 0;
    border-radius: 0.3px;
    width: 100%;
    height: 3px;
    cursor: pointer;
}

input[type=range]::-moz-range-thumb {
    width: 33px;
    height: 20px;
    background: #1a3066;
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    background-image: url("~@/assets/thumb.svg");
    background-size: 9px 7px;
    background-position: center;
    background-repeat: no-repeat;
}

input[type=range]::-ms-track {
    background: transparent;
    border-color: transparent;
    border-width: 12.2px 0;
    color: transparent;
    width: 100%;
    height: 3px;
    cursor: pointer;
}

input[type=range]::-ms-fill-lower {
    background: #0f2b4b;
    border: 0;
    border-radius: 0.6px;
}

input[type=range]::-ms-fill-upper {
    background: #0f2b4b;
    border: 0;
    border-radius: 0.6px;
}

input[type=range]::-ms-thumb {
    width: 33px;
    height: 20px;
    background: #1a3066;
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    margin-top: 0px;
    background-image: url("~@/assets/thumb.svg");
    background-size: 9px 7px;
    background-position: center;
    background-repeat: no-repeat;
    /*Needed to keep the Edge thumb centred*/
}

input[type=range]:focus::-ms-fill-lower {
    background: #3071a9;
}

input[type=range]:focus::-ms-fill-upper {
    background: #367ebd;
}

@supports (-ms-ime-align:auto) {
    input[type=range] {
        margin: 0;
    }
}

</style>
